import HTTP from "@/_helpers/http";
import { ALLNEWUSER__API, DASHBOARDAPIREQ__API } from "@/_helpers/urls";
import { ALLNEWUSER__MUTATIONS, DASHBOARDAPIREQ__MUTATIONS } from "../mutation-types";
import { ALLNEWUSER__ACTIONS, DASHBOARDAPIREQ__ACTIONS } from "../action-types";

// State
const state = {
    clients: [],
    partners: [],
    allPartners: 0,
    totalLiveAccounts: 0,
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [ALLNEWUSER__MUTATIONS.GETALLCLIENTS](state, data) {
        state.clients = data;
    },
    [ALLNEWUSER__MUTATIONS.GETALLPARTNERS](state, data) {
        state.partners = data;
    },
    [DASHBOARDAPIREQ__MUTATIONS.TOTALPARTNERS](state, data) {
        state.allPartners = data?.totalPartners;
    },
    [DASHBOARDAPIREQ__MUTATIONS.TOTALLIVEACCOUNTS](state, data) {
        state.totalLiveAccounts = data?.totalLiveTradingAccounts;
    },
};

// Actions
const actions = {
    async [ALLNEWUSER__ACTIONS.GETALLCLIENTS]({ commit, state }) {
        try {
            const response = await HTTP().get(ALLNEWUSER__API.GETALLCLIENTS);
            commit(ALLNEWUSER__MUTATIONS.GETALLCLIENTS, response.data)
        } catch (error) {
            console.log(error);
        }
    },
    async [ALLNEWUSER__ACTIONS.GETALLPARTNERS]({ commit, state }) {
        try {
            const response = await HTTP().get(ALLNEWUSER__API.GETALLPARTNERS);
            commit(ALLNEWUSER__MUTATIONS.GETALLPARTNERS, response.data)
        } catch (error) {
            console.log(error);
        }
    },
    async [DASHBOARDAPIREQ__ACTIONS.TOTALPARTNERS]({ commit, state }) {
        try {
            const response = await HTTP().get(DASHBOARDAPIREQ__API.TOTALPARTNERS);
            commit(DASHBOARDAPIREQ__MUTATIONS.TOTALPARTNERS, response.data)
        } catch (error) {
            console.log(error);
        }
    },
    async [DASHBOARDAPIREQ__ACTIONS.TOTALLIVEACCOUNTS]({ commit, state }) {
        try {
            const response = await HTTP().get(DASHBOARDAPIREQ__API.TOTALLIVEACCOUNTS);
            commit(DASHBOARDAPIREQ__MUTATIONS.TOTALLIVEACCOUNTS, response.data)
        } catch (error) {
            console.log(error);
        }
    },
    async [ALLNEWUSER__ACTIONS.INSERTNEWUSER]({ dispatch }, data) {
        try {
            await HTTP().post(ALLNEWUSER__API.INSERTNEWUSER, data);
            await dispatch(ALLNEWUSER__ACTIONS.GETALLCLIENTS)
            await dispatch(ALLNEWUSER__ACTIONS.GETALLPARTNERS)
        } catch (error) {
            console.log(error);
        }
    },
    async [ALLNEWUSER__ACTIONS.REMOVENEWUSER]({ dispatch }, id) {
        try {
            await HTTP().delete(`${ALLNEWUSER__API.REMOVENEWUSER}/${id}`);
            await dispatch(ALLNEWUSER__ACTIONS.GETALLCLIENTS)
            await dispatch(ALLNEWUSER__ACTIONS.GETALLPARTNERS)
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
